import { render, staticRenderFns } from "./design.vue?vue&type=template&id=659dff84&scoped=true"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"
import style0 from "./design.vue?vue&type=style&index=0&id=659dff84&prod&lang=less&scoped=true"
import style1 from "./design.vue?vue&type=style&index=1&id=659dff84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659dff84",
  null
  
)

export default component.exports